import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ProCheck } from "./../assets/svgs/pro-check.svg";
import unlimitedRecommendationsBackground from "./../assets/unlock-unlimited-bg.png";
import unlimitedRecommendationsPerson from "./../assets/unlock-unlimited-person.png";
import { ReactComponent as UnlockUnlimitedIcon } from "./../assets/svgs/unlock-unlimited-icon.svg"

const AdvancedMeasurementsProModal = ({
  isOpen,
  onClose,
  isResetMode = false,
}) => {
  const navigate = useNavigate();

  if (!isOpen || typeof document === "undefined") return null;

  const handleUnlock = () => {
    onClose?.();
    navigate("/eveness-pro");
  };

  return createPortal(
    <div className="fixed inset-0 z-[2147483647] flex items-center justify-center bg-black/65 px-4 py-6">
      <div className="relative max-h-[calc(100vh-48px)] w-full max-w-[735px] overflow-y-auto rounded-[5px] bg-white px-8 pb-10 pt-9 shadow-2xl">
        <button
          type="button"
          onClick={onClose}
          className="absolute right-4 top-4 text-[22px] text-[#777] hover:text-black"
        >
          ×
        </button>

        <div className="flex flex-col items-center">
          <h2 className="font-helvena text-[28px] font-medium tracking-[-1%] text-black text-center">
            {isResetMode
              ? "Add Your Advanced Measurements"
              : "Unlock Unlimited Recommendations"}
          </h2>
          <p className="mt-2 font-helvena text-[12px] text-[#8A8580] md:w-[358px] text-center">
            {isResetMode
              ? "Upgrade to pro, to get the most advanced fashion styling advice, tailored to your measurements."
              : "Upload one or more photos, Measurements and enter your email to unlock personalized recommendations."}
          </p>
        </div>

        <div className="relative mx-auto mt-4 h-[180px] w-full max-w-[400px] sm:max-w-[510px] overflow-hidden rounded-[5px] border border-[#E2DEDB] sm:h-[295px]">
          <img
            src={unlimitedRecommendationsBackground}
            alt=""
            aria-hidden="true"
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div className="absolute bottom-[8px] left-[8px] top-[10px] w-[36%] overflow-hidden rounded-[4px] bg-white/85 sm:bottom-[20px] sm:left-[18px] sm:top-[20px]">
            <img
              src={unlimitedRecommendationsPerson}
              alt="Person using Eveness"
              className="absolute bottom-0 left-[85%] h-[100%] w-auto max-w-none -translate-x-1/2 object-contain" />
          </div>
          <div className="absolute bottom-[18px] right-[16px] flex w-[53%] flex-col items-end sm:bottom-[20px] sm:right-[18px]">
            <UnlockUnlimitedIcon className="mb-2 h-auto w-full max-w-[190px]" />
            <p className="text-right font-spaceMono whitespace-nowrap text-[14px] font-normal uppercase leading-[1.2] tracking-[-0.02em] text-white sm:text-[20px]">
              Stop guessing what
              <br />
              suits you the best!!
            </p>
          </div>
        </div>

        <div className="mx-auto mt-5 max-w-[510px] space-y-4">
          {[
            "Unlimited Virtual Try-Ons",
            "Unlimited Fit & Style Match Scores",
            "Advanced Body Measurements",
            "Priority AI Silhouette Analysis",
          ].map((item) => (
            <div key={item} className="flex items-center gap-3">
              <ProCheck />
              <span className="font-helvena text-[15px] text-[#5C5C60]">
                {item}
              </span>
            </div>
          ))}
        </div>

        <div className="h-[95px] mx-auto mt-[10px] flex max-w-[510px] items-center justify-between rounded-[5px] bg-[#252525] p-[24px] text-white">
          <div>
            <div className="font-spaceMono text-[11px] uppercase tracking-[0%] text-[#B8B8BB]">
              PRO PLAN
            </div>
            <div className="mt-1 font-helvena text-[20px] font-semibold">
              Everything, unlimited.
            </div>
          </div>

          <div className="font-spaceMono">
            <span className="text-[32px] font-bold text-[#FCB7BD]">$4.99</span>
            <span className="font-helvena ml-1 text-[14px] text-[#B8B8BB]">
              /mo
            </span>
          </div>
        </div>

        <div className="mx-auto mt-[10px] max-w-[510px]">
          <button
            type="button"
            onClick={handleUnlock}
            className="h-[42px] w-full rounded-[5px] bg-gradient-to-r from-[#EAB5A9] to-[#B76670] font-helvena text-[14px] text-white transition hover:brightness-95"
          >
            Unlock Pro →
          </button>

          <p className="mt-[10px] text-center font-helvena text-[12px] text-[#8A8580]">
            No credit card required&nbsp;&nbsp;&nbsp;•&nbsp;&nbsp;&nbsp;Your
            photo is used only to build your style profile.
          </p>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default AdvancedMeasurementsProModal;
